module.exports = {
      id: "technology-usage",
      viewBox: "0 0 22.958 22.633",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#technology",
      toString: function () {
        return this.url;
      }
    }